import { LOGIN, LOGOUT, SET_PATH, SET_LAST_VIEWED_PROJECT, SET_PREFERS_PROJECTS_LIST_VIEW, } from '../actions/types';

const reducer = (state = {}, action) => {
  if(action.type === LOGIN) {
    return {
      ...state,
      isLoggedIn: true,
      userId: action.payload.userId,
      sessionKey: action.payload.sessionKey,
      path: '',
      lastViewedProjectId: '00000000-0000-0000-0000-000000000000',
    };
  }

  if(action.type === LOGOUT) {
    return {
      ...state,
      isLoggedIn: false,
      userId: '',
      sessionKey: '',
      path: '',
      lastViewedProjectId: '00000000-0000-0000-0000-000000000000',
      prefersProjectsListView: false,
    };
  }

  if(action.type === SET_PATH) {
    return {
      ...state,
      path: action.payload
    };
  }

  if(action.type === SET_LAST_VIEWED_PROJECT) {
    return {
      ...state,
      lastViewedProjectId: action.payload.projectId
    };
  }

  if(action.type === SET_PREFERS_PROJECTS_LIST_VIEW) {
    return {
      ...state,
      prefersProjectsListView: action.payload.prefersProjectsListView
    };
  }

  // default
  return state;
};

export default reducer;
